module.exports = __webpack_public_path__ + "media/Video 7.56f93415.mp4";